(() => {
  'use strict';
  const bind = root => root.querySelectorAll('[data-fabienne-search]:not([data-search-bound])').forEach(form => {
    form.dataset.searchBound = 'true';
    const input = form.querySelector('[name="q"]');
    const type = form.querySelector('[name="type"]');
    const panel = form.querySelector('.search-suggestions');
    const status = form.querySelector('[data-search-status]');
    const results = form.querySelector('[data-search-results]');
    let timer, controller, revision = 0;
    const close = () => { revision++; clearTimeout(timer); controller?.abort(); panel.hidden = true; results.replaceChildren(); status.textContent = ''; };
    const suggest = () => {
      close();
      const query = input.value.trim();
      if (query.length < 2) return;
      const current = revision;
      timer = setTimeout(async () => {
        controller = new AbortController();
        panel.hidden = false;
        status.textContent = form.dataset.loading;
        const url = new URL(form.dataset.predictiveUrl, location.origin);
        url.search = new URLSearchParams({ q: query, section_id: 'fabienne-predictive-search', 'resources[type]': type.value, 'resources[limit]': '6', 'resources[limit_scope]': 'all', 'resources[options][unavailable_products]': 'last' });
        try {
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Search unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-predictive-content]');
          if (!content) throw new Error('Search unavailable');
          if (current !== revision) return;
          results.replaceChildren(content);
          status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError' && current === revision) status.textContent = form.dataset.fallback;
        }
      }, 220);
    };
    input.addEventListener('input', suggest);
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) suggest(); });
    type.addEventListener('change', suggest);
    form.addEventListener('submit', close);
    form.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); input.focus(); close(); } });
    form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
    document.addEventListener('click', event => { if (!form.contains(event.target)) close(); });
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
